import { GetTeamDto } from '../common/pokCore/autogenerated/pokApiClient';

export const teamName = (
  team?: GetTeamDto | null,
  companyName?: string | null,
): string => {
  if (!team?.name) {
    return '';
  }
  const withCompany = companyName ? `${team.name} (${companyName})` : team.name;
  return withCompany;
};
